export const BEAST_PRODUCT_ID = 'fox-ess-h3-plus-the-beast';
export const FOX_ESS_30KW_IMAGE_URL =
  'https://mspd.africa/wp-content/uploads/2025/09/FoxESS-30kW-Front.webp';

export const beastProduct = {
  id: BEAST_PRODUCT_ID,
  name: 'Fox ESS H3 Plus – THE BEAST',
  brand: 'foxess',
  category: 'inverter',
  price: 'Request quote',
  power_range: 'Three-phase hybrid platform',
  description:
    'High-power 3-phase hybrid inverter platform built for commercial-grade solar, battery integration and ultra-fast backup.',
  summary:
    'The Fox ESS H3 Plus – THE BEAST is engineered for high-demand three-phase sites that need rapid backup response, flexible battery architecture, and high efficiency in harsh operating conditions.',
  image_url:
    'https://mspd.africa/wp-content/uploads/2025/10/100_125kW-AKA-The-Beast-Front-View-scaled-e1759927438861.webp',
  highlights: [
    '<10ms EPS switching for rapid backup',
    '100% unbalanced three-phase output',
    '3 battery ports (LFP) with up to 240A total charge/discharge (80A + 80A + 80A)',
    'Up to 98.5% efficiency',
    'IP65 enclosure, smart air cooling',
    '-30C to 60C operating range',
    'Monitoring via FoxCloud (V2.0)',
  ],
  technicalSpecs: [
    { label: 'EPS switching', value: '<10ms' },
    { label: 'Three-phase output', value: '100% unbalanced output supported' },
    { label: 'Battery ports', value: '3 x LFP battery ports' },
    { label: 'Total battery current', value: 'Up to 240A total (80A + 80A + 80A)' },
    { label: 'Max efficiency', value: 'Up to 98.5%' },
    { label: 'Enclosure / cooling', value: 'IP65, smart air cooling' },
    { label: 'Operating temperature', value: '-30C to 60C' },
    { label: 'Monitoring platform', value: 'FoxCloud (V2.0)' },
  ],
  downloads: [
    {
      title: 'Datasheet',
      url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/files/20251204/ENH3PlusDatasheetV2.720251204-904.pdf',
    },
    {
      title: 'Quick Installation Guide',
      url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/files/20251231/ENH3PlusP3PlusGuideV1.3.pdf',
    },
    {
      title: 'User Manual',
      url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/files/20251231/ENH3PlusP3PlusManualV1.2.pdf',
    },
  ],
  videos: [
    {
      title: 'Fox ESS H3 Plus Video',
      provider: 'youtube',
      youtubeId: '_3VhiWi6P2A',
      url: 'https://youtu.be/_3VhiWi6P2A?list=TLGGhf45rAV-Jz8yNjAyMjAyNg',
    },
  ],
  externalLinks: [
    {
      title: 'Fox ESS Official Product Page',
      url: 'https://www.fox-ess.com/products/hybrid-inverter/58',
    },
  ],
};

export const withBeastProduct = (products = []) => {
  const exists = products.some((product) => String(product.id) === BEAST_PRODUCT_ID);
  if (exists) return products;
  return [beastProduct, ...products];
};
